import {ComponentProps, ReactNode, Suspense, lazy} from 'react';
import {ComponentType} from '@react-spring/web';
import Spinner from 'ui/@_components/spinner';

const lazyPage = <T extends ComponentType<any>>(
  lazyProp: Parameters<typeof lazy<T>>[0],
  fallback: ReactNode = <Spinner />
) => {
  const Component = lazy<T>(lazyProp);

  return (props: ComponentProps<typeof Component>) => {
    return (
      <Suspense fallback={fallback}>
        <Component {...props} />
      </Suspense>
    );
  };
};

export default lazyPage;
